import {Component, HostListener, Input, OnDestroy, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscription, UserSubscriptionCategory} from "../../../user/user-subscription";
import * as fromStore from "../../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {FormControl, Validators} from "@angular/forms";
import {User} from "../../../user/user";
import {Utils} from "../../../shared/utils/utils";
import {Subscription} from "rxjs";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import {DbModalService} from "../../../modules/modal/modal";
import {ApiResellerProComponent} from "../../../shared/components/dialogs/api-reseller-pro/api-reseller-pro.component";

export interface IPaymentDialogInput {

  upgradeSubscription?: UserSubscription;
  upgradeSubscriptionId?: number;
  dataCenter?: string;
  renew?: boolean;
  activate?: boolean;
  extend?: boolean;
  extendDomain?: boolean;
  renewDomain?: boolean;
  additionalCount?: any;
  showAdditional?: boolean;
  fromDialog?: boolean;
  nthPlan?: any;
  productSlug?: any;
  buyCdnAddOn?: boolean;
  fromHosting?: boolean;
  forCreate?: boolean;
  websiteId?: number;
  fromBooster?: boolean;
  buyingWordsAddon?: boolean;
  couponNewPrice?: string;
  couponCode?: string;
  renewCouponCode?: string;
  domainInner?: boolean;
  periodTimeSelected?: number;
  fromApiResellerPro?: boolean;
}

@Component({
    selector: 'db-payment-dialog',
    templateUrl: './payment-dialog.component.html',
    styleUrls: ['./payment-dialog.component.scss'],
    standalone: false
})
export class PaymentDialogComponent extends DialogComponent<IPaymentDialogInput, Boolean> implements OnInit, OnDestroy {

    @Input() upgradeSubscription?: UserSubscription;
  @Input() upgradeSubscriptionId?: number;
  @Input() dataCenter?: string;
  @Input() renew: boolean = false;
  @Input() activate?: boolean = false;
  @Input() extend: boolean = false;
  @Input() renewDomain?: boolean = false;
  @Input() extendDomain?: boolean = false;
  @Input() additionalCount?: any;
  @Input() showAdditional?: boolean = false;
  @Input() fromDialog?: boolean = false;
  @Input() nthPlan?: any = 1;
  @Input() buyCdnAddOn?: boolean = false;
  @Input() fromHosting?: boolean = false;
  @Input() forCreate?: boolean = false;
  @Input() websiteId?: number;
  @Input() fromBooster?: boolean;
  @Input() buyingWordsAddon?: boolean;
  @Input() couponNewPrice?: string;
  @Input() couponCode?: string;
  @Input() renewCouponCode?: string;
  @Input() domainInner?: boolean;
  @Input() periodTimeSelected?: any;
  @Input() fromApiResellerPro?: boolean = false;

  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public loading: boolean;
  public user: User;
  public currentSubscription: UserSubscription;

  public paypalErrors: any;
  public userSubscriptionStorage: any;
  public userSubscriptionVisits: any;
  private _subscriptions: Subscription[];
  private _originalDomainInfo: any = null;

  public additionalWebsites: FormControl;
  public additionalWebsitesCount: number = 1;
  public paypalRenew: boolean;
  public ltdAdditionalInfoSites: any;
  public additionalCdn: FormControl;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _modalService: DbModalService
  ) {
    super(_dialogService);
  }

  ngOnInit(): void {
    this.additionalWebsites = new FormControl(this.additionalWebsitesCount, [Validators.pattern(/^[0-9]+$/)]);

    this.addSubscriptions();
    this.getCurrentSubscription();
    this.paypalRenew = this.currentSubscription && this.currentSubscription.status === this.userSubscriptionStatus.canceled && !this.currentSubscription.appsumoIsExpired && this.currentSubscription.paymentType !== 'card' && !Utils.isTruthy(this.currentSubscription.canReactivate);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }


  private getCurrentSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.currentSubscription = userSubscription;
        if (this.currentSubscription && this.currentSubscription.plan && (this.currentSubscription.boosterProClient || this.currentSubscription.category === UserSubscriptionCategory.ENTERPRISE || ((this.currentSubscription.plan.type === UserSubscriptionCategory.DedicatedVM || this.currentSubscription.plan.type === UserSubscriptionCategory.PLATFORM) && (this.showAdditional || this.renew))) ) {
          this.userSubscriptionVisits = userSubscription.plan.services.hosting ? userSubscription.plan.services.hosting.hosting_additional_visits ? parseInt(userSubscription.plan.services.hosting.hosting_additional_visits.parameter_value, 10) : (userSubscription.additionalWebsiteCount ? (parseInt(userSubscription.plan.services.hosting.hosting_visits.parameter_value, 10) + (parseInt(this.currentSubscription.additionalWebsiteCount, 10) * parseInt(userSubscription.plan.services.hosting.hosting_additional_visits.parameter_value, 10))) : parseInt(userSubscription.plan.services.hosting.hosting_visits.parameter_value, 10)) : 0;
          this.userSubscriptionStorage = userSubscription.plan.services.hosting ? userSubscription.plan.services.hosting.hosting_additional_storage ? parseInt(userSubscription.plan.services.hosting.hosting_additional_storage.parameter_value, 10) : (userSubscription.additionalWebsiteCount ? (parseInt(userSubscription.plan.services.hosting.hosting_storage.parameter_value, 10) + (parseInt(this.currentSubscription.additionalWebsiteCount, 10) * parseInt(userSubscription.plan.services.hosting.hosting_additional_storage.parameter_value, 10))) : parseInt(userSubscription.plan.services.hosting.hosting_storage.parameter_value, 10)) : 0;
        }
      });
  }

  public addSubscriptions(): void {
    this._subscriptions = [];

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUser))
        )
        .subscribe((user: User) => {
          this.user = user;
          this.ltdAdditionalInfoSites = this.user && this.user.additionalWebsiteCount ? this.user.additionalWebsiteCount + ' Hosted ' + Utils.wordByCount('site', this.user.additionalWebsiteCount, false) : null;
        })
    );
  }

  removeSubscriptions(): void {
    this._subscriptions && this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
    if ($event.target.id === 'db-dialog-wrapper__close-icon' || $event.target.id === 'db-dialog-wrapper__backdrop-bg') {
      this.cancel();
    }
  }

  public cancel(): void {
    super.close();

    if (this.fromApiResellerPro) {
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
        width: 1240
      };
      const modal = this._modalService.open(ApiResellerProComponent, options);
      modal.componentInstance.currentSubscription = this.currentSubscription;
      modal.componentInstance.user = this.user;
      modal.componentInstance.fromDialog = true;
    }
  }
}
